import React, {
  forwardRef,
  useImperativeHandle,
  useRef,
} from 'react';
import { FormTemplate, FormTemplateSection } from 'data/template/template.types';
import Form, {
  FieldUpdateHandlerParam,
} from 'shared/form';
import './contact-form.scss';
import { FormLayout } from 'components/FormLayout';
import { useTranslation } from 'react-i18next';
import { Contact } from 'data/contact/contact.types';

type Props = {
  template: FormTemplate,
  data: Partial<Contact>,
  showNote?: boolean,
  onFieldUpdate?: (param: FieldUpdateHandlerParam) => void
}

export type Ref = {
  isValid: (forceValidation: boolean, forceTouched: boolean) => boolean
  getValues: () => Contact
}

export const CONTACT_FORM_I18N_KEY = 'contact.form';

export const ContactForm = forwardRef<Ref, Props>(({
  template,
  data,
  showNote = false,
  onFieldUpdate = () => null,
}: Props, ref) => {
  const mainRef = useRef<Form>(null);
  const { t } = useTranslation();

  const isValid = (forceValidation = false, forceTouched = true) => {
    const isMainValid = mainRef.current?.isValid(forceValidation, forceTouched) ?? true;
    return isMainValid;
  };

  const getValues = () => {
    const {
      ...values
    } = mainRef.current?.getValues();

    const formValues: Contact = {
      ...values,
    };

    return formValues;
  };

  useImperativeHandle(ref, () => ({
    isValid,
    getValues,
  }));

  return (
    <div className="contact-form" data-testid="ContactForm">
      <FormLayout>
        <Form
          ref={mainRef}
          name={template.formId ?? template.key}
          defaults={data}
          fields={(template.main as FormTemplateSection).fields}
          layout={(template.main as FormTemplateSection).metadata.layout?.rows}
          fieldUpdateHandler={onFieldUpdate}
          i18nKeyPrefix={CONTACT_FORM_I18N_KEY}
        />
      </FormLayout>
      {showNote && <p className="contact-form-note">{t('contact.dialog.note')}</p>}
    </div>
  );
});

export default ContactForm;
